import { deepFreeze } from '../utils/deepFreeze.js';
import { countries } from './countryArray.js';
import { CountryDefintion } from './countryDefinitions.js';

const nationalityCountriesMapTemp: { [key: string]: string[] } = {};

for (const country of countries) {
  const { nationality, countryName } = country;
  nationalityCountriesMapTemp[nationality] = [...(nationalityCountriesMapTemp[nationality] || []), countryName];
}

const nationalityCountriesMap = deepFreeze(nationalityCountriesMapTemp);

export { nationalityCountriesMap };

export const countryByNationality: { [nationality: string]: CountryDefintion } = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.nationality]: country });
    return prev;
  }, {}),
);

export const countryByCountryName: { [countryName: string]: CountryDefintion } = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.countryName]: country });
    return prev;
  }, {}),
);

export const countryByAlpha3: { [alpha3: string]: CountryDefintion } = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.alphaThree]: country });
    return prev;
  }, {}),
);

export const countryByNumeric: { [numeric: string]: CountryDefintion } = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.numeric]: country });
    return prev;
  }, {}),
);

export const countryByRegionName: { [regionName: string]: CountryDefintion } = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.region]: country });
    return prev;
  }, {}),
);
